import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.array.find";
export default (function () {
  return {
    visitor: {
      Program: {
        leave: function leave(node) {
          if (node.body.find(function (n) {
            return n.type === 'ReturnStatement';
          })) {
            return;
          }

          var lastExpr = node.body.concat().reverse().find(function (n) {
            return n.type === 'ExpressionStatement';
          });

          if (!lastExpr) {
            return;
          }

          var start = lastExpr.start,
              end = lastExpr.end;
          var hasSemi = this.original.substring(start, end).endsWith(';');
          this.appendLeft(start, ';\nreturn (');
          if (hasSemi) this.overwrite(end - 1, end, ');');else this.appendRight(end, ');');
        }
      }
    }
  };
});